import React from "react";
import { useTranslation } from "react-i18next";
import "./CarruselSimple.css";

export default function CarruselSimple() {
  const { t } = useTranslation();
  return (
    <div className="carrusel-simple">
      <img
        src="/equipo1.webp"
        alt={t("alt.our_team") || "Our Team"}
        className="carrusel-simple-img"
      />
      <div className="carrusel-simple-overlay">
        <h2 className="carrusel-simple-title">
          {t("carrusel_simple.title")}
          <br />
        </h2>
      </div>
    </div>
  );
}
